import React from 'react'

import PostCard from './PostCard'

function getRelatedPosts(ghostPost, allGhostPost) {
  const allPosts =
    ghostPost && allGhostPost && allGhostPost.edges
      ? allGhostPost.edges.map(e => e.node)
      : []
  let isRecentPostIncluded = false // We want to include at least one recent, non-matching post for diversity
  return allPosts.filter(p => {
    const isSamePost = p.id === ghostPost.id
    const visibleTags = p.tags.filter(tag => tag.visibility === 'public')
    const matchingTags = visibleTags.filter(
      tag => ghostPost.tags.filter(pt => pt.slug === tag.slug).length > 0
    )
    const isSameTag = matchingTags.length > 0
    if (isSamePost) {
      return false
    } else {
      if (isSameTag) {
        return true
      } else {
        if (!isRecentPostIncluded) {
          isRecentPostIncluded = true
          return true
        }
      }
    }
    return false
  })
}

/** Note: params are to be provided by gql */
const RelatedPosts = ({ pageContext, maybeGhostPost, allGhostPost }) => {
  const relatedPosts = getRelatedPosts(maybeGhostPost, allGhostPost)

  return (
    relatedPosts.length > 0 && (
      <>
        <h2>More stories</h2>
        {relatedPosts.slice(0, 5).map(post => (
          <PostCard key={post.id} post={post} pageContext={pageContext} small />
        ))}
      </>
    )
  )
}

export default RelatedPosts
